"use client";

import Category from "@/components/category/category";
import React from "react";

const CategoryScreen = ({ categoryData, genreData }) => {
  return (
    <div className="h-auto py-24 md:px-16 lg:px-20 flex flex-col items-center justify-center w-full">
      <Category title="دسته‌بندی‌ها" categoryItems={categoryData} />
      <div className="py-5"></div>
      <Category title="ژانرها" genreItems={genreData} />
    </div>
  );
};

export default CategoryScreen;
